module.exports = __webpack_public_path__ + "media/SetB_T2_B.ddd32de3.mp3";